import gql from 'graphql-tag';

export default gql`
  mutation deleteCrewMember($projectId: Int!, $profileId: Int!) {
    deleteCrewMember(projectId: $projectId, profileId: $profileId)
  }
`;
